export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '9288f8d', dateTime: 1784653024609 };